
<ng-container>
  <div [class]="'drag-handle-' + canvasPosition()">
    <div [class]="dragIndicatorClass()">
    </div>
  </div>
</ng-container>
